import React from 'react'

import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import MainForm from './mainForm'

import * as PlantillasGeneralesService from 'services/plantillaGeneralContabilidad.service'

const portletBreadcrumbs = [
  {
    name: 'Plantillas Generales',
    path: `/${CodigosTransaccionesConstant.PLANTILLASGENERALESCONTABILIDAD_LISTA}`
  },
  { name: 'Editar' }
]

const NuevoPage = ({ match }) => {
  const [editarData, setEditarData] = React.useState(null)

  React.useEffect(() => {
    PlantillasGeneralesService.getxIdAsEdicion(match.params.id).then(({ data }) => {
      setEditarData(data)
    })
  }, [match.params.id])

  return (
    <>
      {editarData && (
        <Portlet>
          <Portlet.Header title='Plantillas Generales' breadcrumbs={portletBreadcrumbs} />
          <Portlet.Body>
            <MainForm editarData={editarData} />
          </Portlet.Body>
        </Portlet>
      )}
    </>
  )
}

export default React.memo(NuevoPage)
